<template>
  <v-main>
    <v-row class="d-flex justify-center pt-10">
        <v-col v-if="lang == 'ru'" cols="8">
            <a href="#" @click.prevent="$router.push('/')">Вернуться на главную</a>
            <h1>Согласие на обработку персональных данных</h1>
            <p>
                Используя сайт <strong><a href="https://nitrosbase.ru/" target="_blank">https://nitrosbase.ru/</a></strong> (далее – сайт), 
                я даю согласие на обработку моих персональных данных (далее – Согласие) 
                <strong>Обществом с ограниченной ответственностью «НИТРОСДЭЙТА РУС»</strong>, 
                ИНН 7729660520, адрес: 121205, г. Москва, вн. тер. г. Муниципальный округ Можайский, 
                тер Инновационного Центра Сколково, б-р Большой, д. 42 стр. 1. 
                Фактический адрес: 119571, г. Москва, проспект Вернадского, дом 94, корп. 5 
                (далее — Компания).
            </p>

            <p>
                Я даю согласие на обработку следующих персональных данных:
            </p>
            <ul class="data-list">
                <li>- фамилия</li>
                <li>- имя</li>
                <li>- отчество</li>
                <li>- должность</li>
                <li>- номер телефона</li>
                <li>- адрес электронной почты</li>
            </ul>

            <p>
                Настоящее Согласие признается исполненным в простой письменной форме, и я подтверждаю, 
                что, давая такое Согласие, я действую по своей воле и в своем интересе.
            </p>

            <div class="company-details">
                <strong>Цель обработки</strong> — для использования сервисов сайта, услуг Компании, 
                а также информирования о продуктах и услугах Компании, предложения мне продуктов, 
                услуг и мероприятий Компании.
            </div>

            <p>
                <strong>Срок действия согласия</strong> — до момента его отзыва.
            </p>

            <p>
                Предоставленные мной персональные данные могут быть переданы третьим лицам, 
                осуществляющим обработку персональных данных по поручению Компании, в вышеуказанных целях.
            </p>

            <p>
                Я подтверждаю, что ознакомлен с 
                <strong>«Политикой ООО «НИТРОСДЭЙТА РУС» в отношении обработки персональных данных»</strong>.
            </p>

            <p>
                Я выражаю свое согласие на осуществление со всеми указанными персональными данными 
                следующих действий:
            </p>
            <ul class="action-list">
                <li>- сбор</li>
                <li>- запись</li>
                <li>- систематизацию</li>
                <li>- накопление</li>
                <li>- хранение</li>
                <li>- уточнение (обновление, изменение)</li>
                <li>- извлечение</li>
                <li>- использование</li>
                <li>- передачу (распространение, предоставление, доступ)</li>
                <li>- обезличивание</li>
                <li>- блокирование</li>
                <li>- удаление</li>
                <li>- уничтожение</li>
            </ul>
            <p>
                …а также осуществление любых иных действий с персональными данными в соответствии 
                с действующим законодательством. Обработка данных может осуществляться как с использованием 
                средств автоматизации, так и без их использования (при неавтоматической обработке). 
                При обработке персональных данных Компания не ограничена в применении способов их обработки.
            </p>

            <div class="italic-notice">
                Настоящее согласие может быть отозвано в любое время путем направления Компании заявления,
                соответствующего требованиям ч. 3 ст. 14 Федерального закона № 152‑ФЗ 
                «О персональных данных», на адрес электронной почты: 
                <span class="email-ref"><a href="mailto:support@nitrosbase.ru">support@nitrosbase.ru</a></span>
            </div>

            <div class="revoke-info">
                <strong>⚖️ Обращаем внимание:</strong> Отзыв согласия осуществляется в порядке, установленном 
                законодательством РФ. В случае отзыва согласия Компания вправе продолжить обработку 
                персональных данных без согласия при наличии оснований, указанных в 
                Федеральном законе № 152‑ФЗ (например, для исполнения обязательств по договору).
            </div>
        </v-col>
    </v-row>
  </v-main>
  <footer class="d-flex bg-footer">
      <FooterComp class="w-100"/>
  </footer>
</template>

<script>
import FooterComp from "../../components/FooterComp/FooterComp.vue";
import { mapState } from "vuex";
export default {
    name: "PrivacyPolicy",
    components: {
        FooterComp
    },
    computed: {
        ...mapState(['lang']),
    },
}
</script>

<style>

</style>